import bannerLogo from "../../logo/banner.gif"
import bannerLogoSmall from "../../logo/bannerSmall.gif"
import { Banner } from './banner';

export function DiscountBanner() {
    return (
        <Banner image={bannerLogo} smallImage={bannerLogoSmall} url="/akcijos-ir-naujienos/specialus-pasiulymas?id=145" />
    );
};